export function toggleAddForm() {
    const container = document.getElementById("addFormContainer");
    if (container) {
        container.classList.toggle("hidden");
    }
}

export function changeDate(days) {
    const dateDisplay = document.getElementById("currentDateDisplay");
    if (!dateDisplay?.dataset.serverDate) return;

    const currentDate = new Date(`${dateDisplay.dataset.serverDate}T00:00:00`);
    currentDate.setDate(currentDate.getDate() + days);

    const y = currentDate.getFullYear();
    const m = String(currentDate.getMonth() + 1).padStart(2, "0");
    const d = String(currentDate.getDate()).padStart(2, "0");

    toggleLoadingLocal(true);
    window.location.href = `?date=${y}-${m}-${d}`;
}

export function goToDate(dateValue) {
    if (!dateValue) return;
    toggleLoadingLocal(true);
    window.location.href = `?date=${dateValue}`;
}

export function toggleLoadingLocal(show) {
    const overlay = document.getElementById("loadingOverlay");
    if (overlay) {
        overlay.classList.toggle("hidden", !show);
        overlay.classList.toggle("flex", show);
    }
}
